import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../Button";
import Modal from "../Modal";
import InputField from "../InputField";
import { Colors, Text } from "../../config";
import { useBookingContext } from "../../contexts/BookingContext";
import { createBooking } from "../../services/bookingServices";
import { usePaxContext } from "../../contexts/PassengerContext";
import { useGuestContext } from "../../contexts/GuestContext";
import { useLoaderContext } from "../../contexts/loaderContext";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";

const PriviledgeCardModal = ({
  setClose,
  setOpenRequestSuccessModal,
  onPrivilegeClubChange,
  onError,
}) => {
  const { setLoader } = useLoaderContext();
  const [passengerDetails, setPassengerDetails] = useState([]);
  const [enteredData, setEnteredData] = useState([]);
  const { booking } = useBookingContext();
  const { guests } = useGuestContext();
  const { passengers } = usePaxContext();
  let selectedPax = passengers.filter((item) => item.selected);
  const isPrivilege = selectedPax.length > 0;
  const disabledCondition =
    passengers.every((element) => element.privilegeClub === "") && isPrivilege;
  const { extraFields } = useExtraFieldsContext();

  // const onChange = (e, idx) => {
  //   const newData = enteredData;
  //   newData[idx] = e.target.value;
  //   setEnteredData([...newData]);
  // };

  const handleSubmit = async () => {
    let postObj = {};

    let shallowUpdatedPax = passengers.filter((item) => item.selected);
    let updatedPax = JSON.parse(JSON.stringify(shallowUpdatedPax));
    updatedPax.forEach(function (v) {
      delete v.selected;
      delete v.employeeGroup;
    });
    postObj = { ...booking };
    postObj.membersInfo = [];

    updatedPax.length > 0 && postObj.membersInfo.push(...updatedPax);
    guests.length > 0 && postObj.membersInfo.push(...guests);
    // console.log(postObj);

    let perferAirline = postObj.perferAirline.map(
      (item) => item.selected && item.label
    );

    const expiryDates = [...updatedPax]
      .map((item) => item.expiryDate)
      .filter((date) => date);      

    postObj.perferAirline = perferAirline.filter((airlines) => airlines);
    postObj.companyCode = extraFields.companyCode;
    postObj.lastWorkingDate = extraFields?.lastWorkingDate;
    postObj.expiryDate =
      expiryDates.length > 0
        ? expiryDates.reduce((earliest, current) => {
            return new Date(current) < new Date(earliest) ? current : earliest;
          })
        : "";
    postObj.companyName = extraFields.companyName;
    postObj.grade = extraFields.grade;
    if (!postObj.returnJourney) {
      delete postObj.returnTime;
      delete postObj.returnDate;
    }
    console.log(postObj);
    try {
      setLoader(true);
      const response = await createBooking(postObj);
      if (response.status === 200) {
        setLoader(false);

        const responseData = response.data.data;
        console.log("responseData", responseData);
        setClose();
        setOpenRequestSuccessModal(responseData?.requestId);
      }
    } catch (error) {
      setLoader(false);
      onError(error);
      setClose();
    }
    setLoader(false);
  };

  const handleNoPrivilegeCard = () => {
    //flight details post api and loader
    setClose();
    setOpenRequestSuccessModal(true);
  };
  return (
    <Modal setClose={setClose}>
      <PriviledgeCardContainer>
        {isPrivilege && (
          <PriviledgeCardHeader>
            {Text.doYouHavePrivilegeCard}
          </PriviledgeCardHeader>
        )}
        <InputWrapper>
          {isPrivilege ? (
            passengers.map((eachPass, idx) => {
              return (
                eachPass.selected && (
                  <InputField
                    key={idx}
                    label={`Privilege Card - ${eachPass.firstName}`}
                    labelFontSize="1rem"
                    onChange={(e) => onPrivilegeClubChange(e, idx)}
                    placeholder={Text.enterMembershipNumber}
                    value={passengers.privilegeClub}
                    isRounded
                  />
                )
              );
            })
          ) : (
            <SubheaderText>
              Are you sure you want to submit request?
            </SubheaderText>
          )}
        </InputWrapper>
        <ButtonWrapper>
          <Button
            label={Text.submit}
            onClick={handleSubmit}
            bgColor={Colors.brandTwo}
            topBottomPadding="0.75rem"
            fontSize="1rem"
            fontWeight="500"
            disabled={disabledCondition}
          />

          {isPrivilege && (
            <Button
              label={Text.iDontHavePrivilegeCard}
              onClick={handleSubmit}
              bgColor={Colors.white}
              topBottomPadding="0.75rem"
              fontColor={Colors.black}
              fontSize="1rem"
              fontWeight="400"
              outlineColor={Colors.black}
            />
          )}
        </ButtonWrapper>
      </PriviledgeCardContainer>
    </Modal>
  );
};

export default PriviledgeCardModal;

const PriviledgeCardContainer = styled.div`
  padding: 2.1875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.75rem;
  max-height: 80vh;
  overflow-y: scroll;
  @media only screen and (max-width: 350px) {
    padding: 1rem;
  }
`;
const PriviledgeCardHeader = styled.div`
  font-weight: 700;
  font-size: 1.375rem;
  color: ${Colors.brandOne};
`;
const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 16.75rem;
`;
const SubheaderText = styled.div`
  font-weight: 500;
  font-size: 1.125rem;
  color: ${Colors.shark};
  width: 18.75rem;
  text-align: center;
  @media only screen and (max-width: 478px) {
    width: 15.625rem;
  }
`;
